var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-chip',_vm._g(_vm._b({class:("type--" + _vm.type + " size--" + _vm.size + " " + (_vm.badge ? 'badged' : ''))},'vuetify-chip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }